iteratorWithReturn